module.exports = __webpack_public_path__ + "img/lobby_hosting_wlp.2e54e471.png";